/* eslint-disable react/prop-types */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './ShopDetailsPage.module.scss';

const SDPCertificates = ({ shopInfo }) => {
  return (
    (shopInfo.certificates && shopInfo.certificates.length > 0 && (
      <div className={styles.shopAccolades}>
        <h3 className={styles.accoladeHeading}>
          <FormattedMessage id="shop.certificates" defaultMessage="Certificates" />
        </h3>
        {shopInfo.certificates.map((method, index) => {
          return (
            // Image dimensions: w=100, h=35
            <img
              src={method.image}
              alt={method.name}
              key={method + index}
              title={method.name}
              heigth="35"
              width="100"
            />
          );
        })}
      </div>
    )) ||
    null
  );
};

export default SDPCertificates;
